<div class="agpr-titleDisplay">
    <div
        role="heading"
        [attr.aria-level]="headingLevel"
        [ngStyle]="{
            'text-align': styles?.alignment,
            'background-color': styles?.backgroundColor,
            'font-weight': styles?.bold ? 'bold' : 'normal',
            'color': styles?.color,
            'font-family': styles?.fontFamily,
            'font-size': styles?.fontSize,
            'font-style': styles?.italics ? 'italic' : 'normal',
            'text-decoration': styles?.underlined ? 'underline' : 'none',
            'display': 'block',
            'line-height': '120%',
            'padding-top': styles?.padding.paddingOption
                ? (styles?.padding.topPadding) + 'px'
                : (styles?.padding.paddingAll) + 'px',
            'padding-right': styles?.padding.paddingOption
                ? (styles?.padding.rightPadding) + 'px'
                : (styles?.padding.paddingAll) + 'px',
            'padding-bottom': styles?.padding.paddingOption
                ? (styles?.padding.bottomPadding) + 'px'
                : (styles?.padding.paddingAll) + 'px',
            'padding-left': styles?.padding.paddingOption
                ? (styles?.padding.leftPadding) + 'px'
                : (styles?.padding.paddingAll) + 'px'
        }"
    >
        {{ _data.text }}
    </div>
</div>
